/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer } from 'ethers'
import { Provider, TransactionRequest } from '@ethersproject/providers'
import { Contract, ContractFactory, Overrides } from '@ethersproject/contracts'

import type { OptionLibTester } from '../OptionLibTester'

export class OptionLibTester__factory extends ContractFactory {
  constructor(
    linkLibraryAddresses: OptionLibTesterLibraryAddresses,
    signer?: Signer
  ) {
    super(
      _abi,
      OptionLibTester__factory.linkBytecode(linkLibraryAddresses),
      signer
    )
  }

  static linkBytecode(
    linkLibraryAddresses: OptionLibTesterLibraryAddresses
  ): string {
    let linkedBytecode = _bytecode

    linkedBytecode = linkedBytecode.replace(
      new RegExp('__\\$03106d4e1898139463e4ca6f62fde1e69e\\$__', 'g'),
      linkLibraryAddresses['__$03106d4e1898139463e4ca6f62fde1e69e$__']
        .replace(/^0x/, '')
        .toLowerCase()
    )

    return linkedBytecode
  }

  deploy(overrides?: Overrides): Promise<OptionLibTester> {
    return super.deploy(overrides || {}) as Promise<OptionLibTester>
  }
  getDeployTransaction(overrides?: Overrides): TransactionRequest {
    return super.getDeployTransaction(overrides || {})
  }
  attach(address: string): OptionLibTester {
    return super.attach(address) as OptionLibTester
  }
  connect(signer: Signer): OptionLibTester__factory {
    return super.connect(signer) as OptionLibTester__factory
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): OptionLibTester {
    return new Contract(address, _abi, signerOrProvider) as OptionLibTester
  }
}

const _abi = [
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_accountId',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: '_expiryId',
        type: 'uint256'
      },
      {
        internalType: 'uint128',
        name: '_spot',
        type: 'uint128'
      },
      {
        internalType: 'enum IOptionVault.MarginLevel',
        name: '_marginLevel',
        type: 'uint8'
      }
    ],
    name: 'testGetRequiredCollateral',
    outputs: [
      {
        internalType: 'uint128',
        name: '',
        type: 'uint128'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_collateral',
        type: 'address'
      },
      {
        internalType: 'address',
        name: '_underlying',
        type: 'address'
      },
      {
        internalType: 'address',
        name: '_lendingPool',
        type: 'address'
      }
    ],
    name: 'testInit',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint128',
        name: '_repayAmount',
        type: 'uint128'
      },
      {
        internalType: 'uint128',
        name: '_price',
        type: 'uint128'
      },
      {
        internalType: 'address',
        name: '_caller',
        type: 'address'
      },
      {
        internalType: 'address',
        name: '_feePool',
        type: 'address'
      }
    ],
    name: 'testRedeemCollateralFromLendingPool',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint128',
        name: '_expiryId',
        type: 'uint128'
      },
      {
        internalType: 'uint64',
        name: '_expiry',
        type: 'uint64'
      },
      {
        internalType: 'uint256[]',
        name: '_seriesIds',
        type: 'uint256[]'
      }
    ],
    name: 'testUpdateExpiration',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint128',
        name: '_expiryId',
        type: 'uint128'
      },
      {
        internalType: 'uint256',
        name: '_seriesId',
        type: 'uint256'
      },
      {
        internalType: 'uint128',
        name: '_size',
        type: 'uint128'
      }
    ],
    name: 'testUpdateLong',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_seriesId',
        type: 'uint256'
      },
      {
        internalType: 'uint64',
        name: 'strike',
        type: 'uint64'
      },
      {
        internalType: 'bool',
        name: 'isPut',
        type: 'bool'
      },
      {
        internalType: 'uint64',
        name: 'iv',
        type: 'uint64'
      },
      {
        internalType: 'uint128',
        name: 'expiryId',
        type: 'uint128'
      }
    ],
    name: 'testUpdateSeries',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint128',
        name: '_expiryId',
        type: 'uint128'
      },
      {
        internalType: 'uint256',
        name: '_seriesId',
        type: 'uint256'
      },
      {
        internalType: 'uint128',
        name: '_size',
        type: 'uint128'
      }
    ],
    name: 'testUpdateShort',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  }
]

const _bytecode =
  '0x608060405234801561001057600080fd5b5061089e806100206000396000f3fe608060405234801561001057600080fd5b506004361061007d5760003560e01c8063a9101d401161005b578063a9101d4014610132578063e8750f4c14610145578063eb73f2b3146101b1578063f7635457146101c45761007d565b80632ff526ca146100825780633cc93e20146100f057806345e352a51461011f575b600080fd5b6100ee610090366004610639565b6001600160801b0392831660009081527f13da86008ba1c6922daee3e07db95305ef49ebced9f5467a0b8613fcc6b343e560209081526040808320948352600190940190529190912080546001600160801b03191691909216179055565b005b6101036100fe36600461075e565b61029e565b6040516001600160801b03909116815260200160405180910390f35b6100ee61012d3660046105e2565b610339565b6100ee61014036600461057d565b6103d0565b6100ee610153366004610639565b6001600160801b0392831660009081527f13da86008ba1c6922daee3e07db95305ef49ebced9f5467a0b8613fcc6b343e560209081526040808320948352600290940190529190912080546001600160801b03191691909216179055565b6100ee6101bf36600461067a565b610457565b6100ee6101d23660046107aa565b6040805160808101825267ffffffffffffffff958616815293151560208086019182529386168583019081526001600160801b03938416606087019081526000988952600690955291909620935184549651915167ffffffffffffffff199097169086161768ff0000000000000000191668010000000000000000911515919091021770ffffffffffffffff0000000000000000001916690100000000000000000095909416949094029290921781559051600190910180546001600160801b03191691909216179055565b60405163cf0e577b60e01b815260009073__$03106d4e1898139463e4ca6f62fde1e69e$__9063cf0e577b906102e09084908990899089908990600401610811565b60206040518083038186803b1580156102f857600080fd5b505af415801561030c573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061033091906105bf565b95945050505050565b604051630f30a4f160e11b8152600060048201526001600160801b038086166024830152841660448201526001600160a01b0380841660648301528216608482015273__$03106d4e1898139463e4ca6f62fde1e69e$__90631e6149e29060a40160006040518083038186803b1580156103b257600080fd5b505af41580156103c6573d6000803e3d6000fd5b5050505050505050565b60405163ee9b608f60e01b8152600060048201526001600160a01b03808516602483015280841660448301528216606482015273__$03106d4e1898139463e4ca6f62fde1e69e$__9063ee9b608f9060840160006040518083038186803b15801561043a57600080fd5b505af415801561044e573d6000803e3d6000fd5b50505050505050565b604080516060810182526001600160801b0385811680835267ffffffffffffffff8681166020808601918252858701888152600094855260058252969093208551815492516001600160801b031990931695169490941767ffffffffffffffff60801b1916600160801b919092160217825592518051929391926104e192600185019201906104e9565b505050505050565b828054828255906000526020600020908101928215610524579160200282015b82811115610524578251825591602001919060010190610509565b50610530929150610534565b5090565b5b808211156105305760008155600101610535565b80356001600160a01b038116811461056057600080fd5b919050565b803567ffffffffffffffff8116811461056057600080fd5b600080600060608486031215610591578283fd5b61059a84610549565b92506105a860208501610549565b91506105b660408501610549565b90509250925092565b6000602082840312156105d0578081fd5b81516105db81610879565b9392505050565b600080600080608085870312156105f7578081fd5b843561060281610879565b9350602085013561061281610879565b925061062060408601610549565b915061062e60608601610549565b905092959194509250565b60008060006060848603121561064d578283fd5b833561065881610879565b925060208401359150604084013561066f81610879565b809150509250925092565b60008060006060848603121561068e578283fd5b833561069981610879565b925060206106a8858201610565565b9250604085013567ffffffffffffffff808211156106c4578384fd5b818701915087601f8301126106d7578384fd5b8135818111156106e9576106e9610863565b838102604051601f19603f8301168101818110858211171561070d5761070d610863565b604052828152858101935084860182860187018c101561072b578788fd5b8795505b8386101561074d57803585526001959095019493860193860161072f565b508096505050505050509250925092565b60008060008060808587031215610773578384fd5b8435935060208501359250604085013561078c81610879565b915060608501356003811061079f578182fd5b939692955090935050565b600080600080600060a086880312156107c1578081fd5b853594506107d160208701610565565b9350604086013580151581146107e5578182fd5b92506107f360608701610565565b9150608086013561080381610879565b809150509295509295909350565b85815260208101859052604081018490526001600160801b038316606082015260a081016003831061085357634e487b7160e01b600052602160045260246000fd5b8260808301529695505050505050565b634e487b7160e01b600052604160045260246000fd5b6001600160801b038116811461088e57600080fd5b5056fea164736f6c6343000802000a'

export interface OptionLibTesterLibraryAddresses {
  ['__$03106d4e1898139463e4ca6f62fde1e69e$__']: string
}
